package com.essntl.features.task.domain.di

import org.koin.core.annotation.ComponentScan
import org.koin.core.annotation.Module

@Module
@ComponentScan("com.essntl.features.task.domain.use_case")
class TaskUseCaseModule